import axios from "axios";
import appEnvVariables from "../config/env-variables";
// Set config defaults when creating the instance
const instance = axios.create({
    baseURL: appEnvVariables.API.BASE_URL,
});

export default instance;